import React from "react";

// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

// core components

function LandingPageHeader({ onClickRegisterModal }) {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });
  return (
    <>
      <div className="page-header page-header-small">
        <div
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/bg6.jpg") + ")",
          }}
          ref={pageHeader}
        ></div>
        <div className="content-center">
          <Container>
            <h3 className="title">MSU CHAT</h3>
            <h3>ศูนย์ความเป็นเลิศทางจิตวิทยา</h3>
           
            <Col className="ml-auto mr-auto text-center" md="8">
              <img
                alt="..."
                className="img-fluid img-raised"
                src={require("assets/img/msu_chat_logo.png")}
                style={{ height: '120px' }}
              ></img>
              <br/><br/>
            </Col>
            <Button
              color="info"
              className="btn-round"
              onClick={() => onClickRegisterModal(true)}
            >
              <span style={{fontSize: '20px'}}>ลงทะเบียนเข้ารับบริการ</span>
              </Button> <br />
              <Button
                className="btn-round"
                color="info"
                href={`#counselling-room-page`}
                target="_blank"
              >
                ติดต่อเจ้าหน้าที่
              </Button>
          </Container>
        </div>
      </div>
    </>
  );
}

export default LandingPageHeader;
